// removed by extract-text-webpack-plugin
module.exports = {"header_hexa":"Project__header_hexa__36ky0","footer_hexa":"Project__footer_hexa__3cItu","project":"Project__project__2Es84","project_meta":"Project__project_meta__1_kNo","project_meta_date":"Project__project_meta_date__2QUTV","project_meta_tag":"Project__project_meta_tag__1oNK2","project_information":"Project__project_information__3P9NE","image":"Project__image__-jlnj"};


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Project/Project.scss
// module id = 136
// module chunks = 0